import script from "./ProvidersList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProvidersList.vue?vue&type=script&setup=true&lang=ts"

import "./ProvidersList.vue?vue&type=style&index=0&id=cfbd4550&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfbd4550"]])

export default __exports__